import React from 'react';
import PropTypes from 'prop-types';

import { useWindowSize } from '@react-hook/window-size';
import { ThemeProvider } from '@material-ui/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

import {
  FirstTimeUserChecker,
  ServerChecker,
  VersionChecker,
  StatusIndicator,
} from '../components/index';
import { AppContext } from '../base/AppContext';

import { ChangelogDialog } from '../components/core/Changelog';

export default function IndexContainer(props) {
  const { config, theme, App } = props;
  const [width, height] = useWindowSize();
  const size = { height, width };

  const getTheme = (themeType) => {
    return themeType === 'dark' ? theme.dark : theme.light;
  };

  const [activeTheme, setActiveTheme] = React.useState(getTheme(App.themeType));

  App.config = config;
  App.size = size;
  App.theme = theme;

  React.useEffect(() => {
    App.themeManager.addThemeListener((themeType) => {
      const activeTheme = getTheme(themeType);
      setActiveTheme(activeTheme);
    });
  }, []);
  console.log('[App/indexContainer] Active theme doc:');
  console.log(activeTheme);
  return (
    <ThemeProvider theme={activeTheme}>
      <CssBaseline />
      <AppContext.Provider value={{ App }}>
        {!App.opts.disableServer && (
          <>
            <VersionChecker />
            <ServerChecker />
            <StatusIndicator />
          </>
        )}
        <ChangelogDialog />
        {!App.opts.disableServer && !App.opts.disableUserAccount && (
          <FirstTimeUserChecker />
        )}
        {props.children}
      </AppContext.Provider>
    </ThemeProvider>
  );
}

IndexContainer.propTypes = {
  theme: PropTypes.object,
  config: PropTypes.object,
  children: PropTypes.element.isRequired,
};
